import { HistoryCard } from './HistoryCard';
import { useDeleteGenerationMutation } from './useDeleteGenerationMutation';
import { useHistoryQuery } from './useHistoryQuery';

export function HistoryScreen() {
  const { data, isPending, isError, refetch } = useHistoryQuery();
  const deleteMutation = useDeleteGenerationMutation();

  if (isPending) {
    return <p className="px-6 py-8 text-text-2">Загрузка истории…</p>;
  }

  if (isError) {
    return (
      <div className="px-6 py-8">
        <p className="text-danger">Не удалось загрузить историю. Попробуйте ещё раз.</p>
        <button
          type="button"
          onClick={() => void refetch()}
          className="mt-2 text-sm text-accent hover:underline"
        >
          Повторить
        </button>
      </div>
    );
  }

  if (data.length === 0) {
    return <p className="px-6 py-8 text-text-2">Пока нет ни одной генерации.</p>;
  }

  return (
    <div className="flex flex-col gap-3 px-6 py-8">
      {deleteMutation.isError && (
        <p className="text-sm text-danger">
          {deleteMutation.error instanceof Error
            ? deleteMutation.error.message
            : 'Не удалось удалить генерацию.'}
        </p>
      )}

      <ul className="flex flex-col gap-3">
        {data.map((entry) => (
          <HistoryCard
            key={entry.id}
            entry={entry}
            onDelete={(id) => deleteMutation.mutate(id)}
            isDeleting={deleteMutation.isPending && deleteMutation.variables === entry.id}
          />
        ))}
      </ul>
    </div>
  );
}
